import { render } from "./ArchiveResults.vue?vue&type=template&id=7c4cf047"
import script from "./ArchiveResults.vue?vue&type=script&lang=js"
export * from "./ArchiveResults.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/results/ArchiveResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c4cf047"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c4cf047', __exports__)) {
    console.log('reload')
    api.reload('7c4cf047', __exports__)
  }
  
  module.hot.accept("./ArchiveResults.vue?vue&type=template&id=7c4cf047", () => {
    console.log('re-render')
    api.rerender('7c4cf047', render)
  })

}


export default __exports__